import type { DashboardTabId, ResolveDashboardTabParams } from '../types';

const DASHBOARD_TAB_IDS: DashboardTabId[] = [
    'summary',
    'growth',
    'unit-economics',
    'retention',
    'engagement',
    'organizations',
];

const resolveDashboardTab = ({ pathname }: ResolveDashboardTabParams): DashboardTabId => {
    const matchingTabId = DASHBOARD_TAB_IDS.find(tabId => pathname.endsWith(`/${tabId}`));
    return matchingTabId ?? 'summary';
};

export default resolveDashboardTab;
